module.exports = __webpack_public_path__ + "img/logo.3b035d38.png";